import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router, ROUTER_DIRECTIVES, ActivatedRoute } from '@angular/router';
import { IScenario, ScenarioService, ModifyScenarioFacilitiesRequest, ModifyScenarioFacilitiesResponse } from './scenario.service';
import { AirportService } from '../airports/airport.service';
import { UserSession } from '../shared/user-session';
import {Messages} from 'primeng/primeng';
import { UserInfoService } from '../shared/user-info.service';
import { Dialog } from 'primeng/primeng';
import { AuthService } from '../authentication/auth.service';

@Component({
    template: require('./scenario-modify-facilities.component.html'),
    styles: [require('../styles/faa_styles.css')],
    directives: [ROUTER_DIRECTIVES],
    providers: [ModifyScenarioFacilitiesRequest, ModifyScenarioFacilitiesResponse]
})

export class ScenarioModifyFacilitiesComponent implements OnInit {
    pageTitle: string = 'Scenario Modify Facilities';
    errorMessage: string;
    currentScenario: IScenario;
    sourceScenarios: IScenario[];
    targetScenarios: IScenario[];
    moveCopyLocIdsInput: HTMLInputElement = null;
    moveCopyAirportLocIds: string[];
    deleteLocIdsInput: HTMLInputElement;
    deleteAirportLocIds: string[];
    autoCompleteMoveCopyQuery: string = '';
    autoCompleteMoveCopyFilteredList: string[] = [];
    autoCompleteDeleteQuery: string = '';
    autoCompleteDeleteFilteredList: string[] = [];
    autoCompleteTargetField: string = '';
    scenarioHeaderDiv: HTMLDivElement;
    allScenarios: IScenario[];
    ownScenarios:string ="true";
    msgs: Messages[]=[];
    isScenarioOwner: boolean = false;
    
    constructor(private route: ActivatedRoute,
        private router: Router,
        private request: ModifyScenarioFacilitiesRequest,
        private _scenarioService: ScenarioService,
        private _airportService: AirportService,
        private _userInfoService: UserInfoService,
        private _User: UserSession,
        private authService: AuthService
    ) { }

    @ViewChild('moveCopyLocIds') moveCopyLocIds: ElementRef;
    @ViewChild('deleteLocIds') deleteLocIds: ElementRef;
    @ViewChild('scenarioHeader') scenarioHeader: ElementRef;
    
    ngAfterViewInit() {
        // Bind element references
        this.moveCopyLocIdsInput = this.moveCopyLocIds.nativeElement;
        this.deleteLocIdsInput = this.deleteLocIds.nativeElement;
    }
    ngOnInit() {
        // Retrieve current scenario to set the current selected scenario name
        this._scenarioService.getScenarios(this._User.getSession()['id'])
            .subscribe(
            scenarios =>this.allScenarios = scenarios,
            error => this.errorMessage = <any>error,
            () => {
                if (this._User.hasValidSession()){
                    this.setScenarioHeader(this._User.getSession().scenarioId);
                }
                else {
                    this.setScenarioHeader(this._User.scenarioId);
                    this._User.updateSessionState();
                }
            }
       );

       this.scenarioHeaderDiv = this.scenarioHeader.nativeElement;

       if (typeof (this._User.scenarioId) === 'undefined'){
            this.router.navigate(['./scenario-activities']);
       }

       this._userInfoService.isScenarioOwner(this._User.getSession()['id'], this._User.getSession().scenarioId).subscribe(
            success =>{
                this.isScenarioOwner = success.isOwner; 
                if(this.isScenarioOwner == false && this._User.isAdmin == false){
                    this.msgs = [];
                    this.ownScenarios="false";
                    this.msgs.push({severity:'warn', summary:'Warn Message', detail:'We\'re sorry,  your access level does not permit you to view this page. Contact the TAF administrator to change your access privileges.'});
                }
            },
            error => this.errorMessage = <any>error
        );

        // Request defaults
        this.request.Overwrite = false;
        this.request.operation = 'move';
        this.request.currentScenarioId = this._User.getSession().scenarioId;
        this.request.targetScenarioId = this._User.getSession().scenarioId;
        this.request.deleteScenarioId = this._User.getSession().scenarioId;
      
        /*this._scenarioService.getScenario(this._User.getSession().scenarioId)
            .subscribe(
            scenario => this.currentScenario = scenario,
            error => this.errorMessage = <any>error
            );*/
        // Set list for Source scenarios
        this._scenarioService.getMergeListScenarios("source", this._User.userId)
            .subscribe(
            sourceScenarios => {this.sourceScenarios = sourceScenarios;
                if(this.sourceScenarios.length == 0){
                    this.ownScenarios="false";
                    this.msgs=[];
                    this.msgs.push({severity:'error', summary:'Error Message', 
                            detail: 'Sorry, you do not own any scenario.Please create one scenario if you would like to use this menu.' });
                }
            },
            error => this.errorMessage = <any>error,
            () => {
                this.request.sourceScenarioId = this.sourceScenarios[0].id;

                // Set Airport LocIds for autocomplete text field for Move/Copy
                this._airportService.getAirportLocIds(this.sourceScenarios[0].id)
                    .subscribe(
                    locIds => this.moveCopyAirportLocIds = locIds,
                    error => this.errorMessage = <any>error
                    );
            });

        // Set list for Target Scenarios
        this._scenarioService.getMergeListScenarios("target", this._User.userId)
            .subscribe(
            targetScenarios => this.targetScenarios = targetScenarios,
            error => this.errorMessage = <any>error,
            () => {
                //this.targetScenarios[0].id - this does not work when switching scenarios
                this.request.targetScenarioId = this._User.getSession().scenarioId;
                this.request.deleteScenarioId = this._User.getSession().scenarioId ;

                // Set Airport LocIds for autocomplete text field for Delete
                this._airportService.getAirportLocIds(this._User.getSession().scenarioId)
                    .subscribe(
                    locIds => this.deleteAirportLocIds = locIds,
                    error => this.errorMessage = <any>error
                    );
            });            
    }
    private setScenarioHeader(scenarioId: number): void {
        let foundScenarios: IScenario[] = this.allScenarios.filter(function (scenario) {
            return scenario.id === scenarioId;
        });
        if (foundScenarios.length > 0) {
            this.currentScenario = foundScenarios[0];
        }
        this.scenarioHeaderDiv.innerHTML = `<strong>Current Scenario: ${this.currentScenario.scenarioName} (${this.currentScenario.id})</strong>`;
    }
    onSelectChange(event: Event, type: string, targetSource?: string) {
        let select: HTMLInputElement = event.target as HTMLInputElement;
        if (type === 'source') {
            this.request.sourceScenarioId = +select.value;
            this._airportService.getAirportLocIds(this.request.sourceScenarioId)
                .subscribe(
                locIds => this.moveCopyAirportLocIds = locIds,
                error => this.errorMessage = <any>error
                )
        }

        if (type === 'target' && targetSource === 'movecopy') {
            this.request.targetScenarioId = +select.value;
            this._airportService.getAirportLocIds(this.request.targetScenarioId)
                .subscribe(
                    locIds => {this.moveCopyAirportLocIds = locIds;
                                                             },
                    error => this.errorMessage = <any>error
             )
        }
        if (type === 'target' && targetSource === 'delete') {
            this.request.deleteScenarioId = +select.value;
            this._airportService.getAirportLocIds(this.request.deleteScenarioId)
                .subscribe(
                locIds => this.deleteAirportLocIds = locIds,
                error => this.errorMessage = <any>error
                )
        }
    }

    onChooseActionRadioChange(event: Event, action: string) {
        this.request.operation = action;
    }

    onOverwriteCheckboxChange(event: Event) {
        let checkbox: HTMLInputElement = event.target as HTMLInputElement;
        this.request.Overwrite = checkbox.checked;
    }

    onMoveCopyApply() {
        this.msgs=[];
        if(this.request.operation == "delete"){
            this.request.operation = "move";

        }
        // VALIDATION
        if (this.request.sourceScenarioId === 1 && this.request.operation === 'move') {
            this.msgs=[];
            this.msgs.push({severity:'error', summary:'Error Message', detail: 'You cannot move facilities from the National Scenario. Choose Copy or select another source scenario.'});
            return;
        }
        if (this.request.sourceScenarioId === this.request.targetScenarioId) {
            this.msgs=[];
            this.msgs.push({severity:'error', summary:'Error Message', detail: 'You must choose two different scenarios for Move/Copy'});
            return;
        }
        if(this.moveCopyLocIdsInput === null){
            this.msgs=[];
            this.msgs.push({severity:'error', summary:'Error Message', detail: 'Please choose at least one facility for this operation.'});
            return;
        }
        else{
            let locIds = this.moveCopyLocIdsInput.value.replace(/\s*/g, "").replace(/\'/g, "").toUpperCase();
            //console.log("onMoveCopyApply " +(locIds));
            this.request.locIds = locIds.split(',');
            // Sanitize LocIDs list
            if (this.request.locIds.length === 1 && this.request.locIds[0].length === 0)
                this.request.locIds.pop();
        }
        this._scenarioService.modifyScenarioFacilities(this.request)
            .subscribe(
            (response: ModifyScenarioFacilitiesResponse) => {
                let responseMessage: string = '';
                // Facilities not in Source Scenario
                if (response.notFoundLocIds.length > 0) {
                    responseMessage += 'The following facilities were not found in the source scenario:\r\n';
                    for (let x: number = 0; x < response.notFoundLocIds.length; x++) {
                        responseMessage += `- ${response.notFoundLocIds[x]}\r\n`;
                    }
                    responseMessage += '\r\n';
                }
                // Facilities that have been overwritten
                if (response.overwrittenLocIds.length > 0) {
                    responseMessage += 'The following facilities have been overwritten in the destination scenario:\r\n';
                    for (let x: number = 0; x < response.overwrittenLocIds.length; x++) {
                        responseMessage += `- ${response.overwrittenLocIds[x]}\r\n`;
                    }
                    responseMessage += '\r\n';
                }
                // Facilities that already exist in the destination (not set for overwrite)
                if (response.existingLocIds.length > 0) {
                    responseMessage += `The following facilities already exist in the destination scenario and will not be ${this.request.operation === 'move' ? 'moved' : 'copied'} from the source scenario:\r\n`;
                    for (let x: number = 0; x < response.existingLocIds.length; x++) {
                        responseMessage += `- ${response.existingLocIds[x]}\r\n`;
                    }
                }

                // Facilities that were processed in the move/Copy
                if (response.processedLocIds.length > 0) {
                    responseMessage += `The following facilities where successfully ${this.request.operation === 'move' ? 'moved' : 'copied'}:\r\n`;
                    for (let x: number = 0; x < response.processedLocIds.length; x++) {
                        responseMessage += `- ${response.processedLocIds[x]}\r\n`;
                    }
                }

                this.msgs=[];
                this.msgs.push({severity:'info', summary:'Info Message', detail: responseMessage});
                //this.router.navigate(['./scenario-activities']);
            },
            error => this.errorMessage = <any>error
            );
    }

    onDeleteApply() {
        this.request.operation = "delete";
        let locIds = this.deleteLocIdsInput.value.replace(/\s*/g, "").replace(/\'/g, "").toUpperCase();
        this.request.locIds = locIds.split(',');
        if (locIds.length === 0) {
            this.msgs=[];
            this.msgs.push({severity:'error', summary:'Error Message', detail: 'Please choose at least one facility for this operation!'});
            return;
        }
        this._scenarioService.modifyScenarioFacilities(this.request)
            .subscribe(
            (response: ModifyScenarioFacilitiesResponse) => {
                let responseMessage: string = '';
                // Facilities not in target scenario
                if (response.invalidDeletedLocIds.length > 0) {
                    responseMessage += 'The following facilities were not in the designated scenario and therefore could not be deleted:';
                    for (let x: number = 0; x < response.invalidDeletedLocIds.length; x++) {
                        responseMessage += `- ${response.invalidDeletedLocIds[x]}`;
                    }
                    //responseMessage += "\r\n";
                }
                // Facilities that were deleted
                if (response.deletedLocIds.length > 0) {
                    responseMessage += "Deleted Facilities:";
                    for (let x: number = 0; x < response.deletedLocIds.length; x++) {
                        responseMessage += `- ${response.deletedLocIds[x]}`;
                    }
                }
                this.msgs=[];
                this.msgs.push({severity:'Info', summary:'Info Message', detail: responseMessage});
                //this.router.navigate(['./scenario-activities']);
            },
            error => this.errorMessage = <any>error
            );
    }

    cancel():void {
        this.router.navigate(['./scenario-activities']);
    }

    autoCompleteFilter(targetField: string): void {
        this.autoCompleteTargetField = targetField;
        if (this.autoCompleteMoveCopyQuery.trim().length === 0 && this.autoCompleteDeleteQuery.trim().length === 0) {
            this.autoCompleteMoveCopyFilteredList = [];
            this.autoCompleteDeleteFilteredList = [];
            return;
        }

        if (this.autoCompleteMoveCopyQuery.trim().length > 0) {
            this.autoCompleteMoveCopyFilteredList = this.moveCopyAirportLocIds.filter(function (el: any) {
                return el.toUpperCase().indexOf(this.autoCompleteMoveCopyQuery.split(',')[this.autoCompleteMoveCopyQuery.split(',').length - 1].trim().toUpperCase()) > -1;
            }.bind(this));
        }

        if (this.autoCompleteDeleteQuery.trim().length > 0) {
            this.autoCompleteDeleteFilteredList = this.deleteAirportLocIds.filter(function (el: any) {
                return el.toUpperCase().indexOf(this.autoCompleteDeleteQuery.split(',')[this.autoCompleteDeleteQuery.split(',').length - 1].trim().toUpperCase()) > -1;
            }.bind(this));
        }
    }

    autoCompleteSelect(fieldTarget: string, item: string) {
        let inputValue: string = '';
        if (fieldTarget !== 'movecopy' && fieldTarget !== 'delete')
            return;

        if (fieldTarget === 'movecopy') {
            for (let x: number = 0; x < this.moveCopyLocIdsInput.value.split(',').length - 1; x++) {
                inputValue += this.moveCopyLocIdsInput.value.split(',')[x] + ',';
            }
            this.autoCompleteMoveCopyQuery = inputValue + item;
        }

        if (fieldTarget === 'delete') {
            for (let x: number = 0; x < this.deleteLocIdsInput.value.split(',').length - 1; x++) {
                inputValue += this.deleteLocIdsInput.value.split(',')[x] + ',';
            }
            this.autoCompleteDeleteQuery = inputValue + item;
        }
        this.autoCompleteMoveCopyFilteredList = [];
        this.autoCompleteDeleteFilteredList = [];
    }

}



/** WEBPACK FOOTER **
 ** ./app/scenario-activities/scenario-modify-facilities.component.ts
 **/